module.exports = __webpack_public_path__ + "static/media/page03_front.3bf0d883.png";